import { render } from "./FrontPanel.vue?vue&type=template&id=6519a38d"
import script from "./FrontPanel.vue?vue&type=script&lang=js"
export * from "./FrontPanel.vue?vue&type=script&lang=js"

import "./FrontPanel.vue?vue&type=style&index=0&id=6519a38d&lang=scss"
import "./FrontPanel.vue?vue&type=style&index=1&id=6519a38d&lang=css"

import exportComponent from "c:\\Qedtek Project\\Takayama-New\\takayama_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__